import React from "react";
import BetaBadge from "../BetaBadge/BetaBadge";

type Props = {};

export const EnvironmentLabel: React.FC<Props> = (props) => {
    const isLocal = document.domain.indexOf(":3001") !== -1 || document.domain.indexOf("localhost") !== -1;
    const isStaging = document.domain.indexOf("staging") !== -1;
    const isTesting = document.domain.indexOf("test") !== -1;
    const isNgrok = document.domain.indexOf("ngrok.io") !== -1;
    

    return (
        <div className={"EnvironmentLabel"}>
            {isLocal ? <BetaBadge title={"local"} className={"rounded-5 bg-danger text-dark"} /> : null}
            {isStaging ? <BetaBadge title={"staging"} className={"rounded-5 bg-danger text-dark"} /> : null}
            {isTesting ? <BetaBadge title={"test"} className={"rounded-5 "} /> : null}
            {isNgrok ? <BetaBadge title={"ngrok"} className={"rounded-5 bg-danger text-dark"} /> : null}
        </div>
    );
};
